import React, { useEffect } from "react";

import Table from "react-bootstrap/Table";

import { Payout } from "./Payout";

export default function PayoutsTable({
  payouts,
  bankAccount,
  handleView,
  colSpan = 4,
}) {
  return (
    <>
      <div className="table-container overflow-hidden">
        <Table>
          <thead>
            <tr className="dark">
              <th colSpan={colSpan} className="text-body">
                Destination
              </th>
              <th colSpan={2} className="text-body">
                Amount
              </th>
              <th colSpan={2} className="text-body">
                Status
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {payouts?.map((payout, idx) => (
              <Payout
                key={idx}
                payout={payout}
                handleView={handleView}
                colSpan={colSpan}
                bankAccount={bankAccount}
              />
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}
